import React from 'react';
import { Link, useParams } from 'react-router-dom';

const pages: Record<string, { title: string; body: React.ReactNode }> = {
  cgu: {
    title: 'Conditions d’utilisation',
    body: (
      <>
        <p>
          BookShare est une plateforme de prêt de livres entre particuliers, en phase pilote à
          Bruxelles. Elle n’est pas une bibliothèque publique et ne se substitue pas aux réseaux
          communaux de lecture.
        </p>
        <p>
          L’inscription est gratuite. Le compte Découverte permet un unique emprunt. Les plans
          Lecteur et Collection seront activés après ouverture du paiement. Déposer un livre reste
          gratuit.
        </p>
        <p>
          Les utilisateurs s’engagent à décrire honnêtement l’état des ouvrages, à se présenter au
          lieu de remise convenu, et à restituer le livre dans le délai indiqué. BookShare peut
          suspendre un compte en cas de fraude, de no-show répété ou de dégradation.
        </p>
      </>
    ),
  },
  confidentialite: {
    title: 'Confidentialité',
    body: (
      <>
        <p>
          Nous conservons les données nécessaires au service : identité, email, ville, historique
          d’emprunts, messages liés à une transaction, photos d’état. Elles ne sont pas vendues.
        </p>
        <p>
          Base légale : exécution du contrat de prêt et intérêt légitime de prévention des fraudes.
          Vous pouvez demander l’accès, la rectification ou l’effacement à{' '}
          <a href="mailto:privacy@bookshare.be">privacy@bookshare.be</a>.
        </p>
        <p>Hébergement : Union européenne. Pas de profilage publicitaire.</p>
      </>
    ),
  },
  garantie: {
    title: 'Charte de garantie',
    body: (
      <>
        <p>
          La Protection BookShare s’inspire des garanties de places de marché (caution bloquée,
          preuve, médiation). Elle n’est pas une police d’assurance.
        </p>
        <h2 className="font-serif text-xl text-ink mt-8 mb-2">Pour le prêteur</h2>
        <p>
          Un livre déclaré au-dessus du seuil de valeur exige une caution. Le retour est photographié.
          Si l’état ne correspond pas, une retenue peut être appliquée après examen. Un ouvrage rare
          n’est visible que pour des comptes avec historique ou identité confirmée.
        </p>
        <h2 className="font-serif text-xl text-ink mt-8 mb-2">Pour l’emprunteur</h2>
        <p>
          La caution n’est pas un paiement d’achat. Elle est libérée après validation du propriétaire,
          ou après délai de carence si celui-ci ne répond pas. Les photos de remise vous protègent
          d’une contestation infondée.
        </p>
        <h2 className="font-serif text-xl text-ink mt-8 mb-2">Lieux</h2>
        <p>
          Les échanges du pilote bruxellois se tiennent dans des bibliothèques listées, pendant les
          heures d’ouverture. Un rendez-vous de rue n’est pas couvert par la garantie.
        </p>
      </>
    ),
  },
};

const Legal: React.FC = () => {
  const { slug } = useParams();
  const page = pages[slug || ''] || pages.cgu;

  return (
    <article className="max-w-2xl mx-auto px-4 sm:px-6 py-16">
      <p className="text-xs text-ink-faint mb-4">
        <Link to="/" className="hover:text-ink">
          Accueil
        </Link>
      </p>
      <h1 className="font-serif text-4xl text-ink mb-8">{page.title}</h1>
      <div className="space-y-4 text-ink-muted leading-relaxed text-[15px]">{page.body}</div>
    </article>
  );
};

export default Legal;
